<template>
  <textarea
    ref="textarea"
    :id="id"
    :name="name"
    :value="value"
    class="c-input-textarea"
    :class="{
      'c-input-textarea--error': error,
      'c-input-textarea--has_icon': hasIcon === 'true'
    }"
    :error="error"
    :placeholder="placeholder"
    @input="updateValue"
    :style="addStyle"
    @keydown.shift.enter.exact.prevent
    @keyup.shift.enter.exact="emitKeyupShiftEnter"
  />
</template>

<script>
export default {
  emits: ["input", "input", "keyup-shift-enter"],
  props: {
    id: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    error: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    hasIcon: {
      type: String,
      required: false
    },
    addStyle: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
      this.$nextTick(() => {
        this.resizeTextarea();
      });
    },

    resizeTextarea() {
      const textarea = this.$refs.textarea;
      if (!textarea) {
        return;
      }
      textarea.style.height = "40px";
      textarea.style.height =
      Math.min(
        textarea.scrollHeight,
        160
      ) + "px";
    },
    resetHeight() {
      const textarea = this.$refs.textarea;
      if (!textarea) {
        return;
      }
      textarea.style.height = "40px";
   },
    mounted() {
      this.resizeTextarea();
    },
    emitKeyupShiftEnter() {
      this.$emit("keyup-shift-enter", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.c-input-textarea {
  font-size: rem(14);
  line-height: normal;
  width: 100%;
  height: 40px;
  min-height: 40px;
  max-height: 160px;
  overflow-y: auto;
  border: px(1) solid $common-gray-border;
  border-radius: px(4);
  padding: rem(10) rem(12) rem(11) rem(12);
  display: block;
  resize: none;

  &--error {
    border-color: $error;
  }

  &--has_icon {
    padding-right: px(48+12);
  }

  &::placeholder {
    color: $common-gray300;
  }

  &:focus {
    border-color: $common-black;
  }
}
</style>
